module.exports = __webpack_public_path__ + "static/Images-3-ad18cd41758adb684489e17c01c579ae.png";